<div class="progress_wrapper" *ngIf="isLoading$ | async">
  <mat-spinner></mat-spinner>
</div>
